"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.findChanges = findChanges;
const react_fast_compare_1 = __importDefault(require("react-fast-compare"));
const probabilityChanged_1 = require("./probabilityChanged");
function createMarketChange() {
    return {
        allKeys: new Set(),
        newProbabilities: {},
        changedProbabilities: {},
        deletedKeys: new Set(),
    };
}
function findChanges(groupedProbs, prevOutcomes, vCategoriesInfo, sortedCategoryIds, forcePlayersUpdate = false, probsWithPlayerIdParam = {}) {
    const res = {
        deletedMarkets: new Set(),
        marketsChanges: {},
    };
    // Удаляем не пришедшие категории/маркеты/пробсы
    prevOutcomes.categories.forEach(({ vCategoryId, vMarketIds }) => {
        const isCategoryNotPresent = !groupedProbs[vCategoryId];
        if (isCategoryNotPresent) {
            // Удаляем все связанные ранее виртуальные маркеты
            for (const vMarketId of vMarketIds) {
                res.deletedMarkets.add(vMarketId);
            }
        }
        else {
            vMarketIds.forEach((vMarketId) => {
                if (res.deletedMarkets.has(vMarketId)) {
                    return;
                }
                prevOutcomes.markets[vMarketId].outcomesOrder.forEach((outcomeKey) => {
                    var _a, _b, _c;
                    const marketNotFound = ((_a = groupedProbs[vCategoryId]) === null || _a === void 0 ? void 0 : _a[vMarketId]) === undefined;
                    if (marketNotFound) {
                        if (res.marketsChanges[vMarketId] === undefined) {
                            res.marketsChanges[vMarketId] = createMarketChange();
                        }
                        res.marketsChanges[vMarketId].deletedKeys.add(outcomeKey);
                    }
                    else {
                        const outcomeNotFound = ((_c = (_b = groupedProbs[vCategoryId]) === null || _b === void 0 ? void 0 : _b[vMarketId]) === null || _c === void 0 ? void 0 : _c[outcomeKey]) === undefined;
                        if (outcomeNotFound) {
                            if (res.marketsChanges[vMarketId] === undefined) {
                                res.marketsChanges[vMarketId] = createMarketChange();
                            }
                            res.marketsChanges[vMarketId].deletedKeys.add(outcomeKey);
                        }
                    }
                });
            });
        }
    });
    // Обновляем/добавляем пробсы
    Object.entries(groupedProbs).forEach(([_, marketsByKeys]) => {
        Object.entries(marketsByKeys).forEach(([vMarketId, probsByKeys]) => {
            const prevOutcomesMarket = prevOutcomes.markets[vMarketId];
            Object.entries(probsByKeys).forEach(([outcomeKey, probability]) => {
                var _a;
                // Нашли новый пробс для маркета
                const prevOutcome = (_a = prevOutcomesMarket === null || prevOutcomesMarket === void 0 ? void 0 : prevOutcomesMarket.outcomesByKey) === null || _a === void 0 ? void 0 : _a[outcomeKey];
                if (prevOutcome === undefined) {
                    if (res.marketsChanges[vMarketId] === undefined) {
                        res.marketsChanges[vMarketId] = createMarketChange();
                    }
                    res.marketsChanges[vMarketId].newProbabilities[outcomeKey] =
                        probability;
                    res.marketsChanges[vMarketId].allKeys.add(outcomeKey);
                }
                else if ((0, probabilityChanged_1.probabilityChanged)(probability, prevOutcome)) {
                    if (res.marketsChanges[vMarketId] === undefined) {
                        res.marketsChanges[vMarketId] = createMarketChange();
                    }
                    res.marketsChanges[vMarketId].changedProbabilities[outcomeKey] =
                        probability;
                    res.marketsChanges[vMarketId].allKeys.add(outcomeKey);
                }
                else if (forcePlayersUpdate) {
                    if (res.marketsChanges[vMarketId] === undefined) {
                        res.marketsChanges[vMarketId] = createMarketChange();
                    }
                    const hasPlayerId = probsWithPlayerIdParam[outcomeKey];
                    if (hasPlayerId) {
                        res.marketsChanges[vMarketId].newProbabilities[outcomeKey] =
                            probability;
                        res.marketsChanges[vMarketId].allKeys.add(outcomeKey);
                    }
                }
            });
        });
    });
    const newCategories = [];
    for (const vCategoryId of sortedCategoryIds) {
        const newMarkets = groupedProbs[vCategoryId];
        if (newMarkets === undefined) {
            continue;
        }
        const vCategoryInfo = vCategoriesInfo[vCategoryId];
        if (vCategoriesInfo === undefined) {
            continue;
        }
        const vMarketIds = vCategoryInfo.orderedVirtualMarketIds.filter((vMarketId) => {
            return newMarkets[vMarketId] !== undefined;
        });
        newCategories.push({ vCategoryId, vMarketIds });
    }
    if (!(0, react_fast_compare_1.default)(newCategories, prevOutcomes.categories)) {
        res.changedCategories = newCategories;
    }
    return res;
}
//# sourceMappingURL=findChanges.js.map